export enum RocheGenericLinkIconPosition {
  BEFORE = 'before',
  AFTER = 'after'
}

export enum RocheGenericLinkTarget {
  BLANK = '_blank',
  PARENT = '_parent',
  SELF = '_self',
  TOP = '_top',
}

export enum RocheGenericLinkSize {
  TINY = 'tiny',
  EXTRA_SMALL = 'extra-small',
  SMALL = 'small',
  MEDIUM = 'medium',
  NAVIGATION = 'navigation',
  LARGE = 'large',
  EXTRA_LARGE = 'extra-large',
  HUGE= 'huge',
  EXTRA_HUGE= 'extra-huge'
}
